// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../app/assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../app/assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../app/assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../app/assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../app/assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../app/assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../app/assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../app/assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../app/assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.RecentMedia_scroll__UoQfJ::-webkit-scrollbar {
  height: 8px;
}
.RecentMedia_scroll__UoQfJ::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.RecentMedia_scroll__UoQfJ::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.RecentMedia_RecentMedia__8L4Up {
  background-color: var(--bgColor);
  min-height: 272px;
  padding: 10px;
  position: relative;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-block: 10px;
  -webkit-margin-end: 12px;
          margin-inline-end: 12px;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H svg {
  transition: 0.3s;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H svg:hover {
  color: var(--secondaryColor);
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H svg:hover line {
  stroke: var(--secondaryColor);
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H svg:hover path {
  stroke: var(--secondaryColor);
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H .RecentMedia_ActionBtn__R1hmg {
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H .RecentMedia_ActionBtn__R1hmg:not(:last-child) {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H .RecentMedia_ActionBtn__R1hmg:not(:first-child)::before {
  content: "";
  width: 1px;
  height: 25px;
  background-color: var(--borderColor);
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  margin: 0 10px;
}
body[dir=ltr] .RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H .RecentMedia_ActionBtn__R1hmg:not(:first-child)::before {
  left: -10px;
}
body[dir=rtl] .RecentMedia_RecentMedia__8L4Up .RecentMedia_Actions__4oV5H .RecentMedia_ActionBtn__R1hmg:not(:first-child)::before {
  right: -10px;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_imgVidContainer__AhU5J {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_imgVidContainer__AhU5J .RecentMedia_image__yTIAP {
  padding: 5px;
  width: 70px;
  height: 70px;
  position: relative;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_imgVidContainer__AhU5J .RecentMedia_image__yTIAP img,
.RecentMedia_RecentMedia__8L4Up .RecentMedia_imgVidContainer__AhU5J .RecentMedia_image__yTIAP video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_videoHolder__ByayC {
  position: absolute;
  top: 4px;
  left: 50%;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_videoHolder__ByayC .RecentMedia_playerArrow__SZftg {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 1.5em;
  width: 70px;
  height: 20px;
  cursor: pointer;
}
.RecentMedia_RecentMedia__8L4Up .RecentMedia_instaVideoHolder__zhCxD {
  position: absolute;
  top: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/influencers/components/RecentMedia/RecentMedia.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,gCAAA;EACA,iBAAA;EAEA,aAAA;EACA,kBAAA;AAqDF;AAnDE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;UAAA,uBAAA;AAqDJ;AApDI;EACE,gBAAA;AAsDN;AArDM;EACE,4BAAA;AAuDR;AAtDQ;EACE,6BAAA;AAwDV;AAtDQ;EACE,6BAAA;AAwDV;AAnDI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAqDN;AApDM;EACE,wBAAA;UAAA,uBAAA;AAsDR;AAnDM;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;EAQA,cAAA;AA8CR;AApDQ;EACE,WAAA;AAsDV;AApDQ;EACE,YAAA;AAsDV;AAhDE;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AAkDJ;AAjDI;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAmDN;AAlDM;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAoDR;AA/CE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAiDJ;AAhDI;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAkDN;AA/CE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AAiDJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.RecentMedia {\n  background-color: var(--bgColor);\n  min-height: 272px;\n  // min-width: 366px;\n  padding: 10px;\n  position: relative;\n\n  .Actions {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-block: 10px;\n    margin-inline-end: 12px;\n    svg {\n      transition: 0.3s;\n      &:hover {\n        color: var(--secondaryColor);\n        line {\n          stroke: var(--secondaryColor);\n        }\n        path {\n          stroke: var(--secondaryColor);\n        }\n      }\n    }\n\n    .ActionBtn {\n      flex-shrink: 0;\n      position: relative;\n      cursor: pointer;\n      &:not(:last-child) {\n        margin-inline-end: 10px;\n      }\n\n      &:not(:first-child)::before {\n        content: '';\n        width: 1px;\n        height: 25px;\n        background-color: var(--borderColor);\n        display: block;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(-50%);\n        -moz-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        -o-transform: translateY(-50%);\n        // left: -10px;\n        #{$ltr} & {\n          left: -10px;\n        }\n        #{$rtl} & {\n          right: -10px;\n        }\n        margin: 0 10px;\n      }\n    }\n  }\n  .imgVidContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    .image {\n      padding: 5px;\n      width: 70px;\n      height: 70px;\n      position: relative;\n      img,\n      video {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  .videoHolder {\n    position: absolute;\n    top: 4px;\n    left: 50%;\n    .playerArrow {\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      top: 1.5em;\n      width: 70px;\n      height: 20px;\n      cursor: pointer;\n    }\n  }\n  .instaVideoHolder {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `RecentMedia_scroll__UoQfJ`,
	"RecentMedia": `RecentMedia_RecentMedia__8L4Up`,
	"Actions": `RecentMedia_Actions__4oV5H`,
	"ActionBtn": `RecentMedia_ActionBtn__R1hmg`,
	"imgVidContainer": `RecentMedia_imgVidContainer__AhU5J`,
	"image": `RecentMedia_image__yTIAP`,
	"videoHolder": `RecentMedia_videoHolder__ByayC`,
	"playerArrow": `RecentMedia_playerArrow__SZftg`,
	"instaVideoHolder": `RecentMedia_instaVideoHolder__zhCxD`
};
export default ___CSS_LOADER_EXPORT___;
